import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Button, Flex, Form } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useConfig } from "../../../../_shared";
import { OpenService } from "../../../../types/config";
import { MetaField } from "../../types/MetaField";
import MetaFieldItem from "./MetaFieldItem";

type FormValues = {
  metafields: MetaField[];
};

type Props = {
  btnRef?: React.RefObject<HTMLButtonElement>;
  styles?: {
    submit?: React.CSSProperties;
  };
  afterSave?: () => void;
};

export default observer((props: Props) => {
  const t = useTranslation();
  const [form] = Form.useForm<FormValues>();
  const config = useConfig<MetaField[]>(
    OpenService.ConfigKeys.scheduleMetaFields
  );
  const { message } = useFeedback();

  useEffect(() => {
    if (config.value !== undefined) {
      form.setFieldsValue({ metafields: config.value });
    }
  }, [config.value]);

  async function handleSubmit(values: FormValues) {
    if (await config.saveConfig(JSON.stringify(values.metafields))) {
      message.success(t("maintenance:global.messages.save.success"));
    }
    props.afterSave?.();
  }

  return (
    <Flex vertical gap={12} align="stretch" justify="start">
      <Button
        onClick={() => form.submit()}
        type="primary"
        ref={props.btnRef}
        style={props.styles?.submit}
      >
        {t("maintenance:global.button.save_label")}
      </Button>
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.List name="metafields">
          {(fields, operation, meta) => (
            <>
              {fields.map((field, index) => (
                <MetaFieldItem
                  field={field}
                  key={field.key + index}
                  operation={operation}
                  index={index}
                  form={form}
                />
              ))}
              <Button onClick={() => operation.add()}>
                {t("maintenance:admin.general.schedule.meta.add.label")}
              </Button>
            </>
          )}
        </Form.List>
        <Form.ErrorList />
      </Form>
    </Flex>
  );
});
